"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePoint = exports.getWeeklyWinners = exports.getUserLeaderBoardPoints = exports.getPoints = exports.getPointById = exports.getMonthlyWinners = exports.deletePoint = exports.defaultPointData = exports.createPoint = exports.createBulkPoint = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultPointData = exports.defaultPointData = {
  id: 0,
  enabled: true,
  title: '',
  point: 1,
  isEdit: false
};
const getPoints = params => (0, _request.default)({
  url: '/points',
  method: 'get',
  params
});
exports.getPoints = getPoints;
const getPointById = id => (0, _request.default)({
  url: `/points/${id}`,
  method: 'get'
});
exports.getPointById = getPointById;
const updatePoint = (id, data) => (0, _request.default)({
  url: `/points/${id}`,
  method: 'patch',
  data
});
exports.updatePoint = updatePoint;
const deletePoint = id => (0, _request.default)({
  url: `/points/${id}`,
  method: 'delete'
});
exports.deletePoint = deletePoint;
const createPoint = data => (0, _request.default)({
  url: '/points/',
  method: 'post',
  data
});
exports.createPoint = createPoint;
const createBulkPoint = data => (0, _request.default)({
  url: '/points/bulk',
  method: 'post',
  data
});
exports.createBulkPoint = createBulkPoint;
const getUserLeaderBoardPoints = params => (0, _request.default)({
  url: '/users-points-activity/leaderboard',
  method: 'get',
  params
});
exports.getUserLeaderBoardPoints = getUserLeaderBoardPoints;
const getWeeklyWinners = params => (0, _request.default)({
  url: '/users-points-activity/weekly-winners',
  method: 'get',
  params
});
exports.getWeeklyWinners = getWeeklyWinners;
const getMonthlyWinners = params => (0, _request.default)({
  url: '/users-points-activity/monthly-winners',
  method: 'get',
  params
});
exports.getMonthlyWinners = getMonthlyWinners;